import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
	setArticlesQuery,
	fetchArticles,
	deleteArticle,
	createFiltersSuggestions,
	fetchInstitutionsList,
	dictionaryPaymentModels,
	dictionaryParentalControlRating
} from 'store/actions';
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from './articles_columns';

// Import utilities
import Search from 'components/utilities/search/Search';

// Import components
import { PanelPageTemplate } from 'components/common/templates';
import FilterButton from 'components/common/buttons/FilterButton';

// Import hooks
import useFilterLogic from 'hooks/useFilterLogic';

// Import helpers
import {
	allSubCategories,
	select_products_category
} from 'components/helpers/products_category_sub_category_variables';

const Articles = ({
	error,
	setArticlesQuery,
	fetchArticles,
	deleteArticle,
	resources,
	createFiltersSuggestions,
	fetchInstitutionsList,
	dictionaryPaymentModels,
	dictionaryParentalControlRating,
	filters
}) => {
	const { t } = useTranslation();

	const { columns } = resources;

	// Actions to fetch data for filters
	const filterActions = {
		fetchInstitutionsList,
		dictionaryParentalControlRating,
		dictionaryPaymentModels
	};

	const sub_category = allSubCategories;
	const category = select_products_category;

	const allFilters = { ...filters, sub_category, category };

	useFilterLogic({
		filterActions,
		filters: allFilters,
		createFiltersSuggestions
	});

	return (
		// Dispatch fetchArticles, deleteArticle action in articles_panel
		<PanelPageTemplate
			title="Lista"
			error={error}
			type="articles"
			addLinkText={t('articles:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchArticles}
			deleteItemAction={deleteArticle}
			searchColumn="title"
			notificationDeleteSuccessTxt={t('articles:notification.delete_success')}
			notificationDeleteErrorTxt={t('articles:notification.delete_error')}
		>
			<div className="d-flex justify-content-end">
				<Search
					setQueryValue={setArticlesQuery}
					value={resources.options.filters.query}
				/>
				<FilterButton tableColumns={columns} />
			</div>
		</PanelPageTemplate>
	);
};

Articles.propTypes = {
	error: PropTypes.bool.isRequired,
	setArticlesQuery: PropTypes.func.isRequired,
	resources: PropTypes.object.isRequired,
	fetchArticles: PropTypes.func.isRequired,
	deleteArticle: PropTypes.func.isRequired,
	createFiltersSuggestions: PropTypes.func.isRequired,
	fetchInstitutionsList: PropTypes.func.isRequired,
	dictionaryPaymentModels: PropTypes.func.isRequired,
	dictionaryParentalControlRating: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
	return {
		error: state.articles.table.error,
		resources: state.articles.table,
		filters: {
			institutions: state.dictionary.institutionsList,
			rating: state.dictionary.parentalControlRating,
			payment_models: state.dictionary.paymentModels
		}
	};
};

export default connect(mapStateToProps, {
	setArticlesQuery,
	createFiltersSuggestions,
	fetchArticles,
	deleteArticle,
	fetchInstitutionsList,
	dictionaryPaymentModels,
	dictionaryParentalControlRating
})(Articles);
